import { createContext, useContext } from "react";

/** Interface */
interface ICalculationFormContext {
	isEditing: string[];
	setIsEditing: (ids: string[]) => void;
}

/** Context */
export const CalculationFormContext = createContext<ICalculationFormContext>(
	{} as ICalculationFormContext,
);

/** Hooks */
export function useCalculationFormContext() {
	return useContext(CalculationFormContext);
}
